<template>
<Teleport to="body">
<div class="fixed inset-0 z-[100050] overflow-hidden" role="dialog" aria-modal="true">
    <div class="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity animate__animated animate__fadeIn"></div>
    <div class="absolute inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="pointer-events-none absolute inset-y-0 right-0 flex max-w-full pl-0 sm:pl-10">
                <div class="pointer-events-auto relative w-screen sm:w-[530px] max-w-full">
                    <div class="absolute w-full flex justify-end p-4 z-[9999]">
                        <button @click="$emit('close')" type="button" class="relative rounded-md text-white hover:text-gray-50">
                            <span class="absolute -inset-2.5"></span>
                            <span class="sr-only">Close panel</span>
                            <svg class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    <!-- Slide-over panel -->
                    <div class="h-full overflow-y-auto bg-white animate__animated animate__fadeInRight">
                        <div class="space-y-6 pb-16">
                            <div class="relative flex flex-col items-center mx-auto bg-white bg-clip-border shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:!shadow-none">
                                <div class="relative flex h-[150px] w-full justify-center bg-cover">
                                    <img src='https://horizon-tailwind-react-git-tailwind-components-horizon-ui.vercel.app/static/media/banner.ef572d78f29b0fee0a09.png' class="absolute flex h-[150px] w-full justify-center bg-cover">
                                    <div class="relative bg-teal-400 h-[150px] w-full bg-opacity-[0.75]"></div>
                                    <div class="absolute -bottom-10 flex h-[95px] w-[95px] items-center justify-center rounded-full border-[4px] border-white bg-pink-400 dark:!border-navy-700">
                                        <img class="h-full w-full rounded-full object-cover" :src="student.info.profileImage" alt="" />
                                    </div>
                                </div>
                                <div class="mt-16 mb-1 flex flex-col items-center">
                                    <h4 class="text-xl font-bold text-navy-700 dark:text-white">
                                        {{ student.info.name }}
                                    </h4>
                                    <p class="text-base font-normal text-gray-600">{{ student.info.email }}</p>
                                </div>

                                <div data-te-chip-init data-te-ripple-init class="[word-wrap: break-word] mb-3 mt-1.5 mr-4 flex h-[32px] items-center justify-between rounded-[16px] bg-[#eceff1] px-[12px] py-0 text-[15px] font-bold normal-case leading-loose text-[#4f4f4f] shadow-none transition-[opacity] duration-300 ease-linear hover:!shadow-none active:bg-[#cacfd1] dark:bg-neutral-600 dark:text-neutral-200">
                                    <div class="my-0 -ml-[12px] mr-[8px] h-[inherit] w-[inherit] rounded-[100%]">
                                        <font-awesome-icon icon="fa-duotone fa-loveseat" class="w-6 h-6 py-1 pl-2" />
                                    </div>
                                    {{ organizationSeats }} seats
                                </div>

                                <div class="w-full px-4 sm:px-6">
                                    <div class="border-b border-gray-200">
                                        <nav class="-mb-px grid grid-cols-2 gap-1 sm:flex sm:gap-0 sm:space-x-8" aria-label="Tabs">
                                            <a
                                                @click.prevent="currentTab = 'available'"
                                                href="#"
                                                :class="currentTab == 'available' ? 'text-teal-400 border-b-2 border-teal-400' : 'border-transparent'"
                                                class="flex min-w-0 items-center justify-center border-b-2 px-1 py-3 text-center text-xs font-medium text-gray-500 hover:border-gray-200 hover:text-gray-700 sm:justify-start sm:whitespace-nowrap sm:py-4 sm:text-sm"
                                            >
                                                <font-awesome-icon icon="fa-duotone fa-books" class="mr-1 shrink-0" />
                                                <span class="truncate">Available Content</span>
                                                <span class="ml-1.5 inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-900 sm:ml-3 sm:text-xs md:inline-block">{{ selectedStudentUnassignedIds }}</span>
                                            </a>
                                            <a
                                                @click.prevent="currentTab = 'user'"
                                                href="#"
                                                :class="currentTab == 'user' ? 'text-teal-400 border-b-2 border-teal-400' : 'border-transparent'"
                                                class="flex min-w-0 items-center justify-center border-b-2 px-1 py-3 text-center text-xs font-medium text-gray-500 hover:border-gray-200 hover:text-gray-700 sm:justify-start sm:whitespace-nowrap sm:py-4 sm:text-sm"
                                            >
                                                <font-awesome-icon icon="fa-duotone fa-book-open-reader" class="mr-1 shrink-0" />
                                                <span class="truncate">{{ student.info.name }}'s Content</span>
                                                <span class="ml-1.5 inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium text-gray-900 sm:ml-3 sm:text-xs md:inline-block">{{ selectedStudentAssignedIds }}</span>
                                            </a>
                                        </nav>
                                    </div>
                                </div>

                                <div class="w-full mt-6 px-6">
                                    <div class="w-full" v-for="sport in uniq(filteredCourses.map(c => c.sport))">
                                        <label v-if="currentTab == 'available' && filteredCourses.filter(c => c.sport == sport && !allIds.includes(c.id) && !userContentNotFromThisOrganization.includes(c.id)).length != 0" class="text-xs text-gray-500 uppercase dark:text-gray-400">{{ sport }}</label>
                                        <ul v-if="currentTab == 'available'" role="list" class="px-3 divide-y divide-gray-100">
                                            <li v-for="course in filteredCourses.filter(c => c.sport == sport && !allIds.includes(c.id) && !userContentNotFromThisOrganization.includes(c.id))" :key="course.id" class="flex items-center justify-between gap-x-6 py-5">
                                                <div class="flex min-w-0 gap-x-4" :class="{ 'blur-[1px] opacity-60 pointer-events-none select-none': isPackAssignBlockedForCourse(course) }">
                                                    <img class="h-12 w-12 flex-none rounded-full object-cover bg-gray-50" :src="course.cover" alt="">
                                                    <div class="min-w-0 flex-auto">
                                                        <p class="text-[15px] font-semibold leading-6 text-gray-900">{{ course.name }}</p>
                                                        <p class="text-[15px] font-regular leading-6 text-gray-300">{{ course.type == 'course' ? 'Course' : 'POV' }}</p>
                                                        <p
                                                            v-if="courseRequiresPublishedUpdate(course)"
                                                            class="mt-1 text-xs font-semibold text-amber-800"
                                                        >
                                                            Published update available — update before assigning
                                                        </p>
                                                    </div>
                                                </div>
                                                <div v-if="isPackAssignBlockedForCourse(course)" class="flex flex-col items-end shrink-0 max-w-[140px]">
                                                    <p class="text-[10px] text-gray-500 leading-tight text-right mb-1">{{ packPrerequisiteMessageForCourse(course) }}</p>
                                                    <span class="cursor-not-allowed opacity-40 rounded-full px-2.5 py-1 border text-xs font-semibold text-gray-500 shadow-sm">Assign</span>
                                                </div>
                                                <a v-else-if="!idsAssigning.includes(course.id)" @click.prevent="assignCourse(course)" href="#" class="rounded-full shrink-0 px-2.5 py-1 border text-xs font-semibold bg-teal-400 text-white shadow-sm">Assign</a>
                                                <font-awesome-icon v-if="idsAssigning.includes(course.id)" icon="fa-duotone fa-spinner-third" class="w-6 h-6" spin />
                                            </li>
                                        </ul>

                                        <label v-if="currentTab == 'user' && filteredCourses.filter(c => c.sport == sport && (allIds.includes(c.id) || userContentNotFromThisOrganization.includes(c.id))).length != 0" class="text-xs text-gray-500 uppercase dark:text-gray-400">{{ sport }}</label>
                                            <ul v-if="currentTab == 'user'" role="list" class="px-3 divide-y divide-gray-100">
                                                <li v-for="course in filteredCourses.filter(c => c.sport == sport && (allIds.includes(c.id) || userContentNotFromThisOrganization.includes(c.id)))" class="flex items-center justify-between gap-x-6 py-5">
                                                    <div class="flex min-w-0 gap-x-4">
                                                        <img class="h-12 w-12 flex-none rounded-full object-cover bg-gray-50" :src="course.cover" alt="">
                                                        <div class="min-w-0 flex-auto">
                                                            <p class="text-[15px] font-semibold leading-6 text-gray-900">{{ course.name }}</p>
                                                            <p v-if="!userContentNotFromThisOrganization.includes(course.id)" class="text-[15px] font-regular leading-6 text-gray-300">{{ course.type == 'course' ? 'Course' : 'POV' }}</p>
                                                            <p v-if="userContentNotFromThisOrganization.includes(course.id)" class="text-gray-300">
                                                                <span class="text-[15px]">{{ course.type == 'course' ? 'Course' : 'POV' }}</span>: <span class="text-[12px] font-regular leading-6">Assigned by another organization or individually purchased.</span>
                                                            </p>
                                                            <!-- <p class="mt-1 truncate text-[14px] leading-5 text-gray-500" :class="course.shouldTakeSeats && !mainStore.selectedStudent.consumedIds.includes(course.id) ? 'text-teal-400' : 'text-gray-400'">{{ course.shouldTakeSeats && !mainStore.selectedStudent.consumedIds.includes(course.id) ? '1 seat' : '0 seats' }}</p> -->
                                                        </div>
                                                    </div>
                                                    <a @click.prevent="doNothing()" v-if="!idsUnAssigning.includes(course.id) && userContentNotFromThisOrganization.includes(course.id)" href="#" disabled class="bg-white hover:bg-gray-50 opacity-25 cursor-not-allowed rounded-full px-2.5 py-1 border text-xs font-semibold text-gray-900 shadow-sm">Consumed</a>
                                                    <a @click.prevent="!student.consumedIds.includes(course.id) || course.type == 'pov' ? unassignCourse(course) : doNothing()" v-if="!idsUnAssigning.includes(course.id) && !userContentNotFromThisOrganization.includes(course.id)" href="#" :disabled="student.consumedIds.includes(course.id)" :class="!student.consumedIds.includes(course.id) || course.type == 'pov' ? 'bg-gray-200 text-gray-500 opacity-100' : 'bg-white hover:bg-gray-50 opacity-25 cursor-not-allowed'" class="rounded-full px-2.5 py-1 border text-xs font-semibold text-gray-900 shadow-sm">{{ !student.consumedIds.includes(course.id) ? student.courseIds.includes(course.id) || course.type == 'pov' ? 'Unassign' : 'Assign' : 'Consumed' }}</a>
                                                    <!-- <a @click.prevent="student.courseIds.includes(selectedCourse.id) ? doNothing() : assignCourse(student)" v-if="!idsAssigning.includes(student.info.id)" href="#" :class="student.consumedIds.includes(selectedCourse.id) ? 'cursor-not-allowed' : student.courseIds.includes(selectedCourse.id) ? 'bg-gray-200 text-gray-500' : 'bg-teal-400 text-white'" class="rounded-full px-2.5 py-1 border text-xs font-semibold text-gray-500 shadow-sm">{{ !student.consumedIds.includes(selectedCourse.id) ? student.courseIds.includes(selectedCourse.id) ? 'Unassign' : 'Assign' : 'Consumed' }}</a> -->
                                                    <font-awesome-icon v-if="idsUnAssigning.includes(course.id)" icon="fa-duotone fa-spinner-third" class="w-6 h-6" spin />
                                                </li>
    
                                            </ul>
                                    </div>
                                    <p class="text-center w-full text-gray-400" v-if="currentTab == 'available' && filteredCourses.filter(c => allIds.includes(c.id)).length == 0">No courses found.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div
            v-if="assignUpdatePromptCourse"
            class="fixed inset-0 z-[1000002] flex items-center justify-center bg-black/45 p-4 backdrop-blur-[1px]"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="assign-update-required-title"
            @click.self="assignUpdatePromptCourse = null"
        >
            <div
                class="w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-2xl ring-1 ring-amber-200/90"
                @click.stop
            >
                <div class="border-b border-amber-100 bg-gradient-to-r from-amber-50 to-orange-50/80 px-5 py-4">
                    <div class="flex items-start gap-3">
                        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700" aria-hidden="true">
                            <font-awesome-icon icon="fa-solid fa-triangle-exclamation" class="h-5 w-5" />
                        </span>
                        <div class="min-w-0">
                            <h2 id="assign-update-required-title" class="text-lg font-bold text-gray-900">
                                Update required
                            </h2>
                            <p class="mt-1 text-sm text-amber-950/90">
                                You must update this course before assigning.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="px-5 py-4">
                    <p class="text-sm text-gray-600">
                        Go to your <span class="font-semibold text-gray-800">Educational Courses</span> list and use
                        <span class="font-semibold text-gray-800">Update course</span> so your organization’s copy matches the latest published version. Then return here to assign.
                    </p>
                    <p v-if="assignUpdatePromptCourse?.name" class="mt-2 truncate text-sm font-medium text-gray-900">
                        {{ assignUpdatePromptCourse.name }}
                    </p>
                </div>
                <div class="flex flex-wrap justify-end gap-2 border-t border-gray-100 bg-gray-50/90 px-5 py-4">
                    <button
                        type="button"
                        class="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
                        @click="assignUpdatePromptCourse = null"
                    >
                        Not now
                    </button>
                    <button
                        type="button"
                        class="rounded-lg bg-teal-600 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-teal-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
                        @click="goToCoursesTabToUpdate"
                    >
                        Go to courses
                    </button>
                </div>
            </div>
        </div>
    </Teleport>
</div>
</Teleport>
</template>

<script>
import {
    mapStores
} from 'pinia';
import useMainStore from '@/stores/main';
import {
    organizationEnforcesPackCoursePrerequisite,
    canAssignPackToStudent,
    packPrerequisiteMessageForSport,
    assignmentConsumesOrganizationSeat,
    organizationLacksSeatsForAssignment,
    adjustOrganizationSeatsForAssignment,
} from '@/utils/packAssignmentPrerequisites.js'
import { applyOrganizationLicensingFromApiResponse } from '@/components/refRepsPortal/portalOrganization.js'

export default {
    emits: ['close', 'assignments-updated'],
    props: {
        student: {
            type: Object,
            required: true
        },
        organizationSeats: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            currentTab: 'available',
            searchTerm: '',
            idsAssigning: [],
            idsUnAssigning: [],
            allIds: [],
            allUserContent: [],
            userContentNotFromThisOrganization: [],
            /** Set when user tries to assign a catalog course that is behind published version. */
            assignUpdatePromptCourse: null
        };
    },
    computed: {
        ...mapStores(useMainStore),
        filteredCourses() {
            return this.mainStore.courses.filter(item =>
                item?.name?.toLowerCase().includes(this.searchTerm.toLowerCase())
            );
        },
        selectedStudentAssignedIds() {
            return this.filteredCourses.filter(course => this.student.courseIds.includes(course.id)).length + this.filteredCourses.filter(course => this.student.interactiveIDs.includes(course.id)).length + this.filteredCourses.filter(c => this.userContentNotFromThisOrganization.includes(c.id) && !this.student.interactiveIDs.includes(c.id) && !this.student.courseIds.includes(c.id)).length;
        },
        selectedStudentUnassignedIds() {
            return this.filteredCourses.filter(c => ![...this.student.courseIds, ...this.student.interactiveIDs].includes(c.id) && !this.userContentNotFromThisOrganization.includes(c.id)).length;
        },
        enforcesPackCoursePrerequisite() {
            return organizationEnforcesPackCoursePrerequisite(this.mainStore.organization)
        },
    },
    methods: {
        isPackAssignBlockedForCourse(course) {
            if (!this.enforcesPackCoursePrerequisite || course?.type !== 'pov') {
                return false
            }
            return !canAssignPackToStudent(
                this.student,
                course,
                this.mainStore.organization,
                this.mainStore.courses
            )
        },
        packPrerequisiteMessageForCourse(course) {
            return packPrerequisiteMessageForSport(course?.sport)
        },
        /** Same rules as instructor course detail: org copy version must exist and be less than published `version` (numeric). */
        courseRequiresPublishedUpdate (course) {
            if (!course || course.type !== 'course') {
                return false
            }
            const pubV = course.version
            const instV = course.instructorCourseVersion ?? course.instructor_course_version
            const pubS = pubV != null ? String(pubV).trim() : ''
            const instS = instV != null ? String(instV).trim() : ''
            if (!instS || !pubS) {
                return false
            }
            const pubN = Number(pubV)
            const instN = Number(instV)
            if (!Number.isFinite(pubN) || !Number.isFinite(instN)) {
                return false
            }
            return instN < pubN
        },
        goToCoursesTabToUpdate () {
            if (!this.assignUpdatePromptCourse) {
                return
            }
            const isStatePortal =
                typeof this.$route?.path === 'string' &&
                this.$route.path.startsWith('/state-portal')
            if (isStatePortal) {
                this.assignUpdatePromptCourse = null
                this.$emit('close')
                return
            } else {
                this.mainStore.currentDisplay = 'courses'
                this.mainStore.courseListFilter = 'course'
                this.mainStore.currentCoursePage = 'courseList'
                this.mainStore.course_tab = 'details'
                this.mainStore.showInstructorCourseActions = true
            }
            this.assignUpdatePromptCourse = null
            this.$emit('close')
            if (typeof window !== 'undefined') {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
            }
        },
        pushPullCourse(course) {

            if (this.mainStore.willAssign.map(c => c.id).includes(course.id)) {
                this.mainStore.willAssign = this.mainStore.willAssign.filter(item => item.id != course.id)
                this.projectedSeats = this.mainStore.organization.seats - this.mainStore.willAssign.filter((c) => assignmentConsumesOrganizationSeat(this.mainStore.organization, c)).length
            } else {
                if (this.projectedSeats == 0) return alert('You have no more seats available.')
                this.mainStore.willAssign.push({
                    id: course.id,
                    name: course.name,
                    type: course.type,
                    shouldTakeSeats: course.shouldTakeSeats
                })
                this.projectedSeats = this.mainStore.organization.seats - this.mainStore.willAssign.filter((c) => assignmentConsumesOrganizationSeat(this.mainStore.organization, c)).length
            }
        },
        uniq(a) {
            return Array.from(new Set(a));
        },
        async assignCourse(course) {

            if (this.isPackAssignBlockedForCourse(course)) {
                return
            }

            if (organizationLacksSeatsForAssignment(this.mainStore.organization, course)) {
                return (this.mainStore.showAddSeats = true)
            }

            if (this.courseRequiresPublishedUpdate(course)) {
                this.assignUpdatePromptCourse = course
                return
            }

            const holdOk = await this.mainStore.requestCourseUpdateHoldOn(course, { action: 'assign' })
            if (!holdOk) return

            this.idsAssigning.push(course.id)
            this.axios.post(`${import.meta.env.VITE_BASE_LINK}/assign-course-to-student`, {
                    user_id: this.student.info.id,
                    type: course.type,
                    instructor: this.mainStore.user,
                    companyID: this.$route.params.id,
                    course_id: course.id,
                    userType: course.id == '4CBED23C-C7FA-49F3-A29C-CD1A5B21CBD3' ? this.cheerSelection : 'official'
                })
                .then(async response => {
                    if (response.data.code == 200) {
                        let tempAssignedCourse = null
                        await this.axios.post(`${import.meta.env.VITE_BASE_LINK}/get-assigned-course`, {
                            user_id: this.student.info.id,
                            companyID: this.$route.params.id,
                            course_id: course.id,
                        })
                        .then(response => {
                            tempAssignedCourse = response.data.userCourse
                        })
                        .catch(function (error) {
                            console.log(error);
                        });

                        this.idsAssigning = this.idsAssigning.filter(id => id != course.id)
                        //this.student.courseIds.push(course.id)
                        adjustOrganizationSeatsForAssignment(this.mainStore.organization, course, -1)
                        if (course.type == 'course') {
                            this.student.courseIds.push(course.id)
                            this.student.allUserCourses.push(tempAssignedCourse)
                        } else {
                            this.student.interactiveIDs.push(course.id)
                        }
                        this.getUserCourses()

                        this.$emit('assignments-updated')

                    } else {
                        this.idsAssigning = this.idsAssigning.filter(id => id != course.id)
                        alert('There was an error assigning this course.')
                    }
                })
                .catch(function (error) {
                    alert(error)
                    student.isAssigningCourse = false
                    console.log(error);
                });

        },
        async unassignCourse(course) {

            this.idsUnAssigning.push(course.id)
            await this.axios.post(course.type == 'course' ? `${import.meta.env.VITE_BASE_LINK}/remove-course` : `${import.meta.env.VITE_BASE_LINK}/remove-pack`, {
                    user_id: this.student.info.id,
                    course_id: course.id,
                    companyID: this.$route.params.id,
                    instructor: {name: this.mainStore.user.name, email: this.mainStore.user.email}
                })
                .then(response => {
                    if (response.data.code == 200) {
                        this.idsUnAssigning = this.idsUnAssigning.filter(id => id != course.id)
                        this.student.courseIds = this.student.courseIds.filter(id => id != course.id)
                        if (!applyOrganizationLicensingFromApiResponse(
                            this.mainStore.organization,
                            response.data,
                            this.mainStore.organizations
                        )) {
                            adjustOrganizationSeatsForAssignment(this.mainStore.organization, course, 1)
                        }
                        if (course.type == 'course') {
                            this.student.allUserCourses = this.student.allUserCourses.filter(c => c.id != course.id)
                            this.student.consumedIds = this.student.consumedIds.filter(id => id != course.id)
                        } else {
                            this.student.interactiveIDs = this.student.interactiveIDs.filter(id => id != course.id)
                        }
                        this.getUserCourses()
                        this.$emit('assignments-updated')

                    } else {
                        this.idsUnAssigning = this.idsUnAssigning.filter(id => id != course.id)
                        alert('There was an error un-assigning this course.')
                    }
                })
                .catch(function (error) {
                    alert(error)
                    this.idsUnAssigning = this.idsUnAssigning.filter(id => id != course.id)
                    console.log(error);
                });
        },

        doNothing() {
            return
        },
        getUserCourses() {
            this.allIds = [...this.student.courseIds, ...this.student.interactiveIDs]
        }
    },
    async mounted() {
        this.getUserCourses()
        await this.axios.post(`${import.meta.env.VITE_BASE_LINK}/get-all-user-content`, {
            user_id: this.student.info.id,
        })
        .then(response => {
            this.allUserContent = [...response.data.userCourses, ...response.data.userRepCourses]
            this.userContentNotFromThisOrganization = [...new Set(this.allUserContent.filter(c => !c.assignedBy.companyID || c.assignedBy.companyID !== this.$route.params.id).map(c => c.id))]
        })
        .catch(function (error) {
            alert(error)
            console.log(error);
        });
    },
};
</script>
